import React from 'react';
import TopNav from '../components/top_nav';
import Footer from '../components/footer';

const PrivacyPolicy = () => {
    return (
        <div>
            <TopNav />
            <div
                style={{
                    backgroundColor: '#285eb5',
                    color: 'white',
                    padding: '100px 0px',
                }}
            >
                <h1 className='fs-64 px-md-5 px-2 mx-md-5'>Privacy Policy</h1>
            </div>

            {/* Content Section */}
            <div className="row py-5 justify-content-center mx-0">
                <div className="col-11 border-start-primary-blue-3 ps-3 mb-4">
                    <p className="fs-16 mb-4">
                        We value your trust and are committed to safeguarding your privacy. By continuing to use our website, you
                        acknowledge that you have read and understood this Privacy Policy. We encourage you to review this page
                        periodically to stay informed about how we are protecting your information.
                    </p>
                    <p className="fs-16">
                        If you have any concerns or questions regarding your data or this policy, don’t hesitate to reach out to us.
                    </p>
                </div>

                {/* Detailed Policy */}
                <div className='col-md-10 col-11 text-primary-blue'>
                    <h5 className="fw-bold mb-3">1. Introduction</h5>
                    <p>
                        Welcome to the website of BHEPL (Bharat Heavy Engineering Private Limited) ("Company", "we", "our", or "us").
                        We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains
                        what information we collect, how we use it, and what rights you have in relation to it.
                    </p>

                    <h5 className="fw-bold mt-4">2. Information We Collect</h5>
                    <p>We collect personal information that you voluntarily provide when you:</p>
                    <ul>
                        <li>Subscribe to newsletters or updates</li>
                        <li>Fill out a contact form</li>
                        <li>Apply for a job or internship</li>
                        <li>Interact with any feedback or service inquiry forms</li>
                    </ul>
                    <p>This may include:</p>
                    <ul>
                        <li>Name and email</li>
                        <li>Phone number</li>
                        <li>Organization name</li>
                        <li>IP address</li>
                        <li>Browser/device info (collected via cookies and analytics)</li>
                    </ul>
                    <p>We do not knowingly collect personal data from children under 16 years of age.</p>

                    <h5 className="fw-bold mt-4">3. How We Use Your Information</h5>
                    <p>We use your information to:</p>
                    <ul>
                        <li>Respond to inquiries or service requests</li>
                        <li>Improve website functionality and user experience</li>
                        <li>Communicate with you regarding updates or changes</li>
                        <li>Analyze usage patterns to optimize performance</li>
                        <li>Comply with legal obligations</li>
                    </ul>
                    <p>We do not sell or rent your personal information to third parties.</p>

                    <h5 className="fw-bold mt-4">4. Cookies and Tracking Technologies</h5>
                    <p>
                        We may use cookies, web beacons, and other tracking technologies to collect and store information. This helps us
                        understand user behavior and improve performance. You can choose to disable cookies via your browser settings,
                        but some parts of the website may not function properly.
                    </p>

                    <h5 className="fw-bold mt-4">5. Third-Party Services</h5>
                    <p>Our website may include third-party services such as:</p>
                    <ul>
                        <li>Analytics (Google, etc.)</li>
                        <li>Embedded media (e.g., YouTube, Maps, LinkedIn)</li>
                    </ul>
                    <p>
                        These third-party services operate independently. We encourage you to review their privacy policies.
                    </p>

                    <h5 className="fw-bold mt-4">6. Data Storage and Security</h5>
                    <p>
                        We use appropriate security measures to protect your data from unauthorized access, alteration, disclosure, or
                        destruction. However, no method of transmission over the internet is 100% secure.
                    </p>

                    <h5 className="fw-bold mt-4">7. Your Rights</h5>
                    <p>Depending on applicable data protection law, you may have the right to:</p>
                    <ul>
                        <li>Access your personal data we hold about you</li>
                        <li>Request corrections or deletions</li>
                        <li>Object to processing</li>
                        <li>Withdraw consent</li>
                    </ul>
                    <p>To exercise these rights, contact us.</p>

                    <h5 className="fw-bold mt-4">8. Changes to This Policy</h5>
                    <p>
                        We may update this Privacy Policy from time to time. The updated version will be indicated by a revised “Effective
                        Date” and will be effective as soon as it is accessible.
                    </p>

                    <h5 className="fw-bold mt-4">9. Contact Us</h5>
                    <p>
                        If you have any questions about this Privacy Policy or our data practices, contact:
                        <br /><br/>
                        <strong>BHARAT HEAVY ENGINEERING PVT LTD,<br />
                            Plot No 1/C, Sy No 83/1,<br /> Raidurgam panmaktha Hyderabad Knowledge City,<br />
                            Serilingampally, Hyderabad, Telangana 500081.
                        </strong>
                        <br /><br/>
                        <strong>info@bhepl.com</strong>
                        <br />
                        <strong>+91 9100900144</strong>
                    </p>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy;
